// 客户端激活代码
import '../styles/detail.scss';
import { logInfo } from '../utils/hdflogger';
import createSubtitle from '../components/detailComp/subtitle/createComponent';
import createImage from '../components/detailComp/image/createComponent';
import createAudio from '../components/detailComp/audio/createComponent';
import createVideo from '../components/detailComp/video/createComponent';
import { proxyLinkClick } from '../utils/link/proxyLink';
import '../utils/configVue';
import previewImage from '../utils/previewImage';
const hydration = async ({ env = 'web' }, componentProps = {}) => {
  const defaultProps = {
    env: 'web'
  };
  const enableJsbridge = componentProps['hdf-video'] && componentProps['hdf-video'].enableJsbridge;
  const hydrationCom = function (className, createComponent, props) {
    Array.from(document.getElementsByClassName(className)).forEach(dom => {
      const datasetProps = getDeltaFromDomNode(dom, false);
      const componentProps = Object.assign({}, defaultProps, props, datasetProps);
      const { component } = createComponent(componentProps);
      try {
        component.$mount();
        dom.replaceChild(component.$el, dom.firstElementChild);
      } catch (e) {
        logInfo('error', 'hydration-error', { className });
      }
    });
  };

  const customComponentsClassNames = {
    'hdf-subtitle': createSubtitle,
    'hdf-image': createImage,
    'hdf-audio': createAudio,
    'hdf-video': createVideo
  };

  for (const className of Object.keys(customComponentsClassNames)) {
    if (Array.from(document.getElementsByClassName(className)).length > 0) {
      hydrationCom(
        className,
        customComponentsClassNames[className],
        { env, ...componentProps[className] }
      );
    }
  }
  // 劫持a链接的点击事件
  proxyLinkClick({ env, enableJsbridge });
};
// dataset数据集转换为驼峰再存储成delta
function camelCaseDataset(string) {
  const map = ['attachmentId', 'thumbnailUrl', 'originUrl'].reduce((acc, cur) => {
    acc.set(cur.toLowerCase(), cur);
    return acc;
  }, new Map());
  return map.has(string) ? map.get(string) : string;
}
// 从domNode上获取delta数据
// getUrl, 只有在服务端渲染时才从dataset上取url
// getUrl 只有video时为true
function getDeltaFromDomNode(node, getUrl = true) {
  const props = {};
  if (node.firstElementChild.dataset) {
    for (const key in node.firstElementChild.dataset) {
      if (key === 'url' && getUrl) {
        // 跳过url的获取，delta从node上取数据时会进
        continue;
      }
      props[camelCaseDataset(key)] = node.firstElementChild.dataset[key];
    }
  } else {
    const attrs = node.firstElementChild.attributes;
    for (const attr of attrs) {
      const match = attr.name.match(/^data-(.+)/);
      if (match) {
        const key = match[1];
        if (key === 'url' && getUrl) {
          // 跳过url的获取，delta从node上取数据时会进
          continue;
        }
        props[camelCaseDataset(key)] = attr.value;
      }
    }
  }
  return props;
}
window.hydration = hydration;
window.previewImage = previewImage;
export { previewImage };
export default hydration;
